import isElement from '../../scripts/util/isElement';
import ScrollMagic from 'ScrollMagic';
import TweenMax from 'TweenMax';
import TimelineMax from 'TimelineMax';
import isViewport from '../../scripts/util/window/isViewport';
import {lg} from '../../scripts/util/window/isViewport';
import {mouseAnimate} from '../adaptive/';
import 'animation.gsap';
import 'debug.addIndicators';
import question from '../support/question';
import 'imagesloaded';
import $ from 'jquery';
// import popup from '../support-category/popup';

const selectors = {
	dynamic: '.js-dynamic-image',
	page: '.js-main-page',
	site: {
		trigger: '.js-site-trigger',
		categories: '.js-site-categories',
		previews: '.js-site-previews',
		text: '.js-site-text'
	},
	beside: {
		trigger: '.js-beside-trigger',
		left: '.js-beside-left',
		right: '.js-beside-right',
		head: '.js-beside-head'
	},
	design: {
		trigger: '.js-design-trigger',
		slider: '.js-design-slider'
	},
	idea: {
		trigger: {
			text: '.js-idea-trigger',
			devices: '.js-idea-devices',
			slider: '.js-trigger-device-slide'
		},
		head: '.js-idea-head',
		count: '.js-idea-count',
		countUpdate: '.js-idea-count-update',
		mac: '.js-idea-mac',
		iphone: '.js-idea-iphone',
		ipad: '.js-idea-ipad',
		device: '.idea-wait__device',
		image: '.idea-wait__image',
		sliderMac: '#sliser-gadget-mac',
		sliderPhone: '#sliser-gadget-phone',
		sliderDescr: '.js--slider-description'
	},
	reviews: {
		count: '.js-reviews-count'
	},
	infocard: {
		trigger: {
			step01: '.card-step01',
			step02: '.card-step02',
			step03: '.card-step03'
		}
	}
};

const classes = {
	site: {
		textActive: 'site__text_state_active'
	},
	idea: {
		notActive: 'idea-wait__device',
		active: 'idea-wait__device-active'
	}
};

const needSiteAnim = controller => {
	const trigger = document.querySelector(selectors.site.trigger);
	const categories = document.querySelector(selectors.site.categories);
	const previews = document.querySelector(selectors.site.previews);
	const text = document.querySelector(selectors.site.text);
	const setActive = () => text.classList.add(classes.site.textActive);

	if (trigger !== null) {
		const siteTween = new TimelineMax()
			.add([
				TweenMax.fromTo(categories, 1, {y: 300, x: 0, opacity: 0.4}, {y: 0, x: 0, opacity: 1, ease: 'easeOut'}),
				TweenMax.fromTo(previews, 1, {x: 0, y: 400, opacity: 0.4}, {y: 0, x: 0, opacity: 1, ease: 'easeOut'}),
				TweenMax.fromTo(trigger, 1, {x: 0, y: 100}, {x: 0, y: 0, ease: 'easeOut'})
			]);

		const textTween = TweenMax.fromTo(text, 1, {x: 0, y: 50}, {x: 0, y: -50});

		new ScrollMagic.Scene({
			triggerElement: trigger,
			offset: -800,
			duration: 1100
		}).setTween(siteTween).addTo(controller);

		new ScrollMagic.Scene({
			triggerElement: text,
			triggerHook: 'onEnter',
			duration: '100%'
		}).on('start', setActive).setTween(textTween).addTo(controller);
	}
};

const besideAnim = controller => {
	const trigger = document.querySelector(selectors.beside.trigger);
	const left = document.querySelector(selectors.beside.left);
	const right = document.querySelector(selectors.beside.right);
	// const head = document.querySelector(selectors.beside.head);

	const tweenHands = new TimelineMax()
		.add([
			TweenMax.fromTo(left, 1, {x: -200, y: 0, opacity: 0.7}, {y: 0, x: 0, opacity: 1, ease: 'easeOut'}),
			TweenMax.fromTo(right, 1, {x: 200, y: 0, opacity: 0.7}, {y: 0, x: 0, opacity: 1, ease: 'easeOut'})
			// TweenMax.fromTo(head, 1, {x: 0, y: 200}, {y: 0, x: 0, ease: 'easeOut'})
		]);

	new ScrollMagic.Scene({
		triggerElement: trigger,
		triggerHook: 'onCenter',
		offset: -350,
		duration: 800
	}).setTween(tweenHands).addTo(controller);
};

const designAnim = controller => {
	const trigger = document.querySelector(selectors.design.trigger);
	const slider = document.querySelector(selectors.design.slider);

	const tween = TweenMax.fromTo(slider, 1, {x: 0, y: 300, opacity: 0.4}, {x: 0, y: 0, opacity: 1, ease: 'easeOut'});

	new ScrollMagic.Scene({
		triggerElement: trigger,
		triggerHook: 'onCenter',
		offset: -600,
		duration: 1100
	}).setTween(tween).addTo(controller);
};

const dynamicLoader = (images, index) => {
	const image = $(images[index]);
	if (index < images.length) {
		index++;
	}
	image.on('load', function () {
		dynamicLoader(images, index);
	});
	image.attr('src', image.data('src'));
};

const ideaAnim = controller => {
	const triggerText = document.querySelector(selectors.idea.trigger.text);
	const triggerDevices = document.querySelector(selectors.idea.trigger.devices);
	const head = document.querySelector(selectors.idea.head);
	const count = document.querySelector(selectors.idea.count);
	const countUpdate = document.querySelector(selectors.idea.countUpdate);
	const mac = document.querySelector(selectors.idea.mac);
	const iphone = document.querySelector(selectors.idea.iphone);
	const ipad = document.querySelector(selectors.idea.ipad);

	if (count !== null && head !== null) {
		const tweenText = new TimelineMax()
			.add([
				TweenMax.fromTo(head, 1, {x: 0, y: 20}, {x: 0, y: -60, ease: 'easeOut'}),
				TweenMax.fromTo(count, 1, {x: 0, y: 400}, {x: 0, y: -100, ease: 'easeOut'})
			]);
		new ScrollMagic.Scene({
			triggerElement: triggerText,
			triggerHook: 'onCenter',
			offset: -150,
			duration: 700
		}).setTween(tweenText).addTo(controller);
	}
	if (countUpdate !== null) {
		const tweenTextUpdate = new TimelineMax()
			.add([
				TweenMax.fromTo(countUpdate, 1, {x: 0, y: 500}, {x: 0, y: 180, ease: 'easeOut'})
			]);
		new ScrollMagic.Scene({
			triggerElement: triggerText,
			triggerHook: 'onCenter',
			offset: -150,
			duration: 700
		}).setTween(tweenTextUpdate).addTo(controller);
	}
	if (mac !== null && iphone !== null && ipad !== null) {
		const tweenDevices = new TimelineMax()
			.add([
				TweenMax.fromTo(mac, 1, {x: 0, y: 230}, {x: 0, y: 0, ease: 'easeOut'}),
				TweenMax.fromTo(iphone, 1, {x: 0, y: -80}, {x: 0, y: 0, ease: 'easeOut'}),
				TweenMax.fromTo(ipad, 1, {x: 0, y: 50}, {x: 0, y: 0, ease: 'easeOut'})
			]);
		new ScrollMagic.Scene({
			triggerElement: triggerDevices,
			triggerHook: 'onCenter',
			offset: -100,
			duration: '100%'
		}).setTween(tweenDevices).addTo(controller);
	}
};

const reviewsAnim = controller => {
	const count = document.querySelector(selectors.reviews.count);

	const tween = TweenMax.fromTo(count, 1, {x: 0, y: 50}, {x: 0, y: -100});

	new ScrollMagic.Scene({
		triggerElement: count,
		triggerHook: 'onEnter',
		duration: '100%'
	}).setTween(tween).addTo(controller);
};


const preloadImages = (images, callback) => {
	let counter = 0;
	let i;
	function onLoad() {
		counter++;
		if (counter === images.length) {
			callback();
		}
	}
	for (i = 0; i < images.length; i++) {
		const img = document.createElement('img');
		img.onload = img.onerror = onLoad;
		img.src = images[i].src;
	}
};

const ideaWaitImagesLoader = () => {
	preloadImages($(selectors.idea.image), function () {
		$(selectors.idea.device).addClass(classes.idea.active);
	});
};

const sliderGadget = (selector, timeSlide) => {
	const gadgetDevice = selector;
	const triggerDevicesSlider = document.querySelector(selectors.idea.trigger.slider);
	const fonGadget = $(gadgetDevice).find('.idea-wait__slider-fon');
	if (gadgetDevice !== null) {
		fonGadget.imagesLoaded(function () {
			fonGadget.addClass('is--image-load');
		});
		$(triggerDevicesSlider).imagesLoaded(function () {
			const deviceSlider = $(gadgetDevice).find('.slider-main-items');
			const deviceSlide = deviceSlider.find('.slider-main-item');
			deviceSlider.addClass('is--images-loaded');
			deviceSlider.slick({
				accessibility: false,
				prevArrow: '',
				nextArrow: '',
				autoplay: true,
				autoplaySpeed: 3000,
				infinite: true,
				dots: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: false,
				variableWidth: true,
				focusOnSelect: false,
				fade: true,
				touchMove: false,
				swipe: false,
				pauseOnFocus: false,
				pauseOnHover: false
			});
			deviceSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
				setTimeout(function () {
					deviceSlide.eq(nextSlide).addClass('is--change-slide');
				}, timeSlide);
				setTimeout(function () {
					deviceSlide.eq(currentSlide).removeClass('is--change-slide');
				}, timeSlide * 2);
			});
		});
	}
};


const sliderGadgetAnim = controller => {
	const trigger = document.querySelector(selectors.idea.trigger.slider);
	const sliderMac = document.querySelector(selectors.idea.sliderMac);
	const sliderPhone = document.querySelector(selectors.idea.sliderPhone);
	const sliderText = document.querySelector(selectors.idea.sliderDescr);

	if (sliderMac !== null) {
		const tweenDevices = new TimelineMax()
			.add([
				TweenMax.fromTo(sliderMac, 1, {x: 0, y: 200}, {x: 0, y: 0, ease: 'easeOut'}),
				TweenMax.fromTo(sliderText, 1, {x: 0, y: 200}, {x: 0, y: -70, ease: 'easeOut'}),
				TweenMax.fromTo(sliderPhone, 1, {x: 0, y: 350}, {x: 0, y: 0, ease: 'easeOut'})
			]);
		new ScrollMagic.Scene({
			triggerElement: trigger,
			triggerHook: 'onCenter',
			offset: -100,
			duration: '100%'
		}).setTween(tweenDevices).addTo(controller);
	}
};

const render = () => {
	if (isElement(selectors.page)) {
		ideaWaitImagesLoader();
		setTimeout( () => {
			sliderGadget(document.querySelector(selectors.idea.sliderMac), 750);
			sliderGadget(document.querySelector(selectors.idea.sliderText), 750);
		}, 0);
		setTimeout( () => {
			sliderGadget(document.querySelector(selectors.idea.sliderPhone), 750);
		}, 150);
	}
	if (!isViewport(lg) && isElement(selectors.page)) {
		const controller = new ScrollMagic.Controller();
		needSiteAnim(controller);
		besideAnim(controller);
		designAnim(controller);
		sliderGadgetAnim(controller);
		ideaAnim(controller);
		reviewsAnim(controller);
		mouseAnimate();
	}
	if (isElement('.beside')) {
		question();
		// popup();
	}

};

export {
	selectors
};

export default render;
